import store from "../../../store";
import { Template } from "./templateApi";
import {
  UPDATE_TEMPLATES,
  ADD_TEMPLATES,
  REMOVE_TEMPLATE_BY_ROOT_UUID,
} from "./templateReducer";

export function updateTemplates(payload: Template[]) {
  return store.dispatch(UPDATE_TEMPLATES(payload));
}

export function addNewTemplate(payload: Template) {
  return store.dispatch(ADD_TEMPLATES(payload));
}

export function removeTemplateByRootUuid(rootComponentUuid: string) {
  return store.dispatch(REMOVE_TEMPLATE_BY_ROOT_UUID({ rootComponentUuid }));
}